import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AffiliatesJoinPopup } from "../components/affiliates/content/joinAffiliates/AffiliatesJoinPopup ";
import { NonAppliedScreen } from "../components/profile/affiliates/layout/NonAppliedScreen";
import { ProfileAffiliatesHeaderMobile } from "../components/profile/affiliates/layout/ProfileAffiliatesHeaderMobile";
import { ProfileDesktopSideBar } from "../components/profile/content/layout/ProfileDesktopSideBar";
import { ProfileMobileSideBar } from "../components/profile/content/layout/ProfileMobileSideBar";
import { AffiliatesMainContent } from "../components/profile/content/mainContent/AffiliatesMainContent";
import { useLanguageTheme } from "../hooks/useLanguageTheme";
import { useUserProfile } from "../hooks/useUserProfile";
import { setProfileSideMenuClose } from "../store/features/profileSlice";
import { useAppDispatch } from "../store/store";
import React from "react";

const PersonalDetails = () => {
  const is970px = useMediaQuery("(max-width: 970px)");
  return (
    <div>
      {is970px && <ProfileAffiliatesHeaderMobile />}
      <div className="non-applied-screen-main-title">Personal Details</div>
    </div>
  );
};

const Security = () => {
  const is970px = useMediaQuery("(max-width: 970px)");
  return (
    <div>
      {is970px && <ProfileAffiliatesHeaderMobile />}

      <div className="non-applied-screen-main-title">Security</div>
    </div>
  );
};

const Notifications = () => {
  const is970px = useMediaQuery("(max-width: 970px)");
  return (
    <div>
      {is970px && <ProfileAffiliatesHeaderMobile />}
      <div className="non-applied-screen-main-title">Notifications</div>
    </div>
  );
};

export const Profile = () => {
  const [sidebarWidth, setSidebarWidth] = useState(343);
  const is970px = useMediaQuery("(max-width: 970px)");
  const dispatch = useAppDispatch();
  const langTheme = useLanguageTheme();

  const { profile, isLoading }: { profile: any; isLoading: boolean } =
    useUserProfile();

  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    return searchParams.get("tab") || "affiliates";
  });

  const handleTabChange = (newTab: string) => {
    if (newTab !== activeTab) {
      setSearchParams({ tab: newTab });
      setActiveTab(newTab);

      if (is970px) {
        dispatch(setProfileSideMenuClose());
      }
    }
  };

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  const renderContent = React.useMemo(() => {
    switch (activeTab) {
      case "personal":
        return <PersonalDetails />;
      case "security":
        return <Security />;
      case "notifications":
        return <Notifications />;
      case "affiliates":
        return isLoading ? (
          <></>
        ) : profile?.affiliateLink !== null ? (
          <AffiliatesMainContent sidebarWidth={sidebarWidth} />
        ) : (
          <NonAppliedScreen />
        );
      default:
        return null;
    }
  }, [activeTab, isLoading, profile, sidebarWidth]);

  return (
    <div
      className="profile-container"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      {!is970px && (
        <ProfileDesktopSideBar
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          setSidebarWidth={setSidebarWidth}
        />
      )}
      <main className="profile-content">{renderContent}</main>
      <ProfileMobileSideBar
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />
      <AffiliatesJoinPopup />
    </div>
  );
};
